export const CartSymbol = {
  ADD: '+',
  REMOVE: '-',
};
